<script>
export default {
    name: "SupplierTransaction",

    data() {

        return {
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                supplierID: ''
            },
            transactions: [],
            suppliers: [],
            summary: {},
        };
    },

    watch: {

        "filter.dateFrom"() {

            if(this.filter.dateTo && this.filter.supplierID && this.filter.dateFrom) {
                this.fetchAll();
            }
        },

        "filter.dateTo"() {

            if(this.filter.dateTo && this.filter.supplierID && this.filter.dateFrom) {
                this.fetchAll();
            }
        },

        "filter.supplierID"() {

            if(this.filter.dateTo && this.filter.supplierID && this.filter.dateFrom) {
                this.fetchAll();
            }
        },
    },

    mounted() {

        this.fetchSuppliers();
    },

    methods: {

        fetchAll() {
            this.$root.loading = true;
            this.$accountsHttp
                .get(`SupplierStatement/GetSupplierStatement?supplierId=${this.filter.supplierID}&dateFrom=${this.filter.dateTo}&dateTo=${this.filter.dateFrom}`)
                .then(response => {
                    this.transactions = response.data
                    this.fetchSummary();
                    this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchSummary() {
            this.$root.loading = true;
            this.$accountsHttp.get(`SupplierStatement/GetSupplierStatementSummary?supplierId=${this.filter.supplierID}&dateFrom=${this.filter.dateTo}&dateTo=${this.filter.dateFrom}`).then(response => {
                this.summary = response.data;
                this.$root.loading = false;
            }).catch(()=> { this.$root.loading = false; });
        },

        fetchSuppliers() {
            this.$root.loading = true;
            this.$accountsHttp.get(`Shared/Suppliers`).then(response => {
                this.suppliers = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        printReceipt(url) {

            if(this.filter.dateTo && this.filter.supplierID && this.filter.dateFrom) {
                window.open(url, 'Transaction Preview', 'left=200,top=200,width=700,height=700,tollbar=0,scrollbars=1,status=0,resizable=1');
            }
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="font-medium text-sm">Supplier Statements</h5>
        </template>
        <template v-slot:card-body>
            <div class="flex md:flex-row sm:flex-col w-full">
                <div class="flex-1 p-tiny">
                    <label for="date-from" class="label-control">Date From:</label>
                    <input type="date" v-model="filter.dateFrom" id="date-from" class="input-control input-sm text-xs">
                </div>
                <div class="flex-1 p-tiny">
                    <label for="date-to" class="label-control">Date To:</label>
                    <input type="date" v-model="filter.dateTo" id="date-to" class="input-control input-sm text-xs">
                </div>
                

                 <div class="flex-1 p-tiny">
                  <label for="grid-cashier" class="label-control">Supplier:</label>
                  <v-select
                v-model="filter.supplierID" 
                :options="suppliers" 
                :reduce="supplier => supplier.id"
                label="name"
                class="bg-white text-sm" 
            />
              </div>
               <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="() => {
                        $root.loading=true;
                        fetchAll().then(() => {
                            $root.loading=false;
                        }).catch(() => { $root.loading=false; });
                    }">
                        <i class="fa fa-filter"></i> Filter</button>
              </div> 
            </div>
            <div class="w-full overflow-auto">
                <table class="table table-hover">
                    <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny w-1/6">Trans Date</th>
                            <th class="p-tiny w-1/6">Trans Type</th>
                            <th class="p-tiny w-1/6">Trans Ref</th>
                            <th class="p-tiny w-1/6">Trans Desc</th>
                            <th class="p-tiny w-1/6">Debit</th>
                            <th class="p-tiny w-1/12">Credit</th>
                            <th class="p-tiny w-1/12">Running Balance</th>
                        </tr>
                    </thead>
                    <tbody class="flex flex-col items-center text-xs overflow-auto bg-gray-100" style="height:57vh;">
                        <tr class="flex w-full" v-for="(transaction, idx) in transactions" :key="idx">
                            <td class="p-tiny w-1/6">{{ transaction.transDate }}</td>
                            <td class="p-tiny w-1/6">{{ transaction.transType }}</td>
                            <td class="p-tiny w-1/6">{{ transaction.transRef }}</td>
                            <td class="p-tiny w-1/6">{{ transaction.transDesc }}</td>
                            <td class="p-tiny w-1/6">{{ transaction.debit }}</td>
                            <td class="p-tiny w-1/12">{{ transaction.credit }}</td>
                            <td class="p-tiny w-1/12">{{ transaction.runningBalance | numberFormat }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex w-full flex-wrap bg-gray-200 border-2 p-2 mt-6">
                <div class="flex-1 p-1">
                <h4 class="font-bold text-center">0-30 Days: <span class="text-blue-400">{{ summary._0to30Days ? (summary._0to30Days | numberFormat) : '-' }}</span></h4>
                </div>
                <div class="flex-1 p-1">
                    <h4 class="font-bold text-center">31-60 Days: <span class="text-blue-400">{{ summary._31to60Days ? (summary._31to60Days | numberFormat) : '-' }}</span></h4>
                </div>
                <div class="flex-1 p-1">
                    <h4 class="font-bold text-center">91-120 Days: <span class="text-blue-400">{{ summary._61to90Days ? (summary._61to90Days | numberFormat) : '-' }}</span></h4>
                </div>
                <div class="flex-1 p-1">
                    <h4 class="font-bold text-center">Over-120 Days: <span class="text-blue-400">{{ summary.over120Days ? (summary.over120Days | numberFormat) : '-'  }}</span></h4>
                </div>
                <div class="flex-1 p-1">
                    <h4 class="font-bold text-center">Totals: <span class="text-blue-400">{{ summary.runningBalance ? (summary.runningBalance | numberFormat) : '-' }}</span></h4>
                </div>
            </div>
            <div class="flex w-full justify-end p-2">
                
            </div>
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
             <router-link :to="{ name: `suppliers-dashboard.index` }" class="btn-sm btn-danger text-xs rounded mr-6"><i class="fa fa-caret-left"></i> Back</router-link>
            <button class="btn-primary btn-sm text-xs rounded" @click.prevent="printReceipt(`/suppliers-dashboard/supplier-statement-report/print?supplierID=${filter.supplierID}&dateFrom=${filter.dateFrom}&dateTo=${filter.dateTo}`)">
                    <i class="fa fa-print"></i> Preview
                    </button>
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
